class MaximumSavedAddressesError extends Error {
	constructor() {
		super('Exceeded maximum of 10 allowed saved addresses')
		this.name = 'MaximumSavedAddressesError'
	}
}

export default MaximumSavedAddressesError
